/** Local dummy assets when API has no banner / logo (served from `public/`). */
const base = (process.env.PUBLIC_URL || "").replace(/\/$/, "");

export const PLACEHOLDER_BANNER_URL = `${base}/assets/images/placeholder-banner.svg`;
export const PLACEHOLDER_LOGO_URL = `${base}/assets/images/placeholder-logo.svg`;
